import "./CategoryOfGoods.scss";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useAppSelector } from "Hooks/useAppSelector";
import { fetchApi } from "Utils/fetchApi";
import { getAltDescription } from "Utils/getAltDescription";
import { IntersectionObserverWrapper } from "Components/IntersectionObserverWrapper/IntersectionObserverWrapper";
import { GoodsCarousel } from "Components/GoodsCarousel/GoodsCarousel";
import { addImpressionsGTM } from "Utils/analyticEvents";
export const CategoryOfGoods = ({ category, className, gtmList, intersectionCallback, location, serverProductsData, urlPath, }) => {
    const isServerRender = !!(serverProductsData === null || serverProductsData === void 0 ? void 0 : serverProductsData.data.length);
    const { genderData } = useAppSelector((state) => state.app);
    const { user } = useAppSelector((state) => state.userInfo);
    const [isLoading, setIsLoading] = useState(isServerRender ? false : true);
    const intersectionObserverClassName = `categoryOfGoods__carousel__${category}`;
    const [isCarouselIntersected, setIsCarouselIntersected] = useState(false);
    const [categoryOfGoodsData, setCategoryOfGoodsData] = useState((serverProductsData === null || serverProductsData === void 0 ? void 0 : serverProductsData.data) || []);
    const [catalogLinkData, setCatalogLinkData] = useState((serverProductsData === null || serverProductsData === void 0 ? void 0 : serverProductsData.catalogLink) || null);
    const [title, setTitle] = useState((serverProductsData === null || serverProductsData === void 0 ? void 0 : serverProductsData.title) || null);
    useEffect(() => {
        if (isCarouselIntersected && !isServerRender) {
            setIsLoading(true);
            fetchApi({
                method: "GET",
                url: `/${urlPath}/${category}/?sex=${genderData.genderNumber}&allSizes=1&&withSizes=1`,
            }).then(({ data }) => {
                setCatalogLinkData(data.catalogLink);
                setCategoryOfGoodsData(data.data);
                setTitle(data.title);
                setIsLoading(false);
                if (!isAnaliticsSent && gtmList) {
                    setIsAnaliticsSent(true);
                    addImpressionsGTM({ productsList: data.data, listInfo: gtmList });
                }
            });
        }
    }, [isCarouselIntersected, genderData.genderNumber, user]);
    const [isAnaliticsSent, setIsAnaliticsSent] = useState(isServerRender);
    return (React.createElement(React.Fragment, null,
        categoryOfGoodsData.length > 0 && (React.createElement(Helmet, null,
            React.createElement("script", { type: 'application/ld+json' }, JSON.stringify([
                {
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    name: `Карусель товаров из категории - ${category}`,
                    itemListOrder: "https://schema.org/ItemListOrderAscending",
                    numberOfItems: categoryOfGoodsData === null || categoryOfGoodsData === void 0 ? void 0 : categoryOfGoodsData.length,
                    itemListElement: categoryOfGoodsData === null || categoryOfGoodsData === void 0 ? void 0 : categoryOfGoodsData.map((product, idx) => ({
                        "@type": "ListItem",
                        position: idx + 1,
                        item: {
                            "@type": "Product",
                            name: `${product.model}${product.model_full ? " " + product.model_full : ""}`,
                            brand: {
                                "@type": "Brand",
                                logo: product.brand.image,
                                name: product.brand.name,
                            },
                            image: product.image,
                            description: getAltDescription(product),
                            offers: {
                                "@type": "Offer",
                                availability: `https://schema.org/${(product === null || product === void 0 ? void 0 : product.notAvailable) ? "OutOf" : "In"}Stock`,
                                price: product.actual_price,
                                priceCurrency: "RUB",
                            },
                        },
                    })),
                },
            ])))),
        React.createElement("div", { className: "categoryOfGoods__wrapper" + (className ? " " + className : "") },
            isLoading ? (React.createElement("div", { className: 'categoryOfGoods__title_skeleton skeletonLoading' })) : (title && React.createElement("h2", { className: 'categoryOfGoods__title typography_title' }, title)),
            React.createElement("div", { className: 'categoryOfGoods__carousel' },
                React.createElement(IntersectionObserverWrapper, { observerCallback: () => {
                        intersectionCallback && intersectionCallback();
                        setIsCarouselIntersected(true);
                    }, options: { rootMargin: "400px" }, querySelector: `.${intersectionObserverClassName}`, wasOnScreen: isServerRender, children: React.createElement(GoodsCarousel, { carouselLocation: location, catalogLink: catalogLinkData, category: category, categoryOfGoodsData: categoryOfGoodsData, gtmList: gtmList, intersectionObserverClassName: intersectionObserverClassName, isLoading: isLoading }) })))));
};
